import { FormEvent } from 'react';

export const InputUtils = {
  sliceNumberMaxLength: (e: FormEvent<HTMLInputElement>): string => {
    if (e.currentTarget.value.length > e.currentTarget.maxLength) {
      e.currentTarget.value = e.currentTarget.value.slice(0, e.currentTarget.maxLength);
      return e.currentTarget.value.slice(0, e.currentTarget.maxLength);
    }
    return e.currentTarget.value;
  },

  onlyKorCanInput: (e: React.FormEvent<HTMLInputElement>) => {
    if (!/^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/.test(e.currentTarget.value)) {
      e.currentTarget.value = e.currentTarget.value.replace(/[^ㄱ-ㅎㅏ-ㅣ가-힣]/g, '');
    }
  },

  onlyKorAndEngAndSpaceCanInput: (e: React.FormEvent<HTMLInputElement>) => {
    if (!/^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/.test(e.currentTarget.value)) {
      e.currentTarget.value = e.currentTarget.value.replace(/[^ㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z\s]/g, '');
    }
  },

  onlyEngWithSpaceCanInput: (e: React.FormEvent<HTMLInputElement>) => {
    if (!/^[a-zA-Z\s]*$/.test(e.currentTarget.value)) {
      e.currentTarget.value = e.currentTarget.value.replace(/[^a-zA-Z\s]/g, '');
    }
  },

  onlyNumberCanInput: (e: React.FormEvent<HTMLInputElement>) => {
    e.currentTarget.value = e.currentTarget.value.replace(/[^0-9]/g, '');
  },

  onlyNumberWithDecimalPointCanInput: (e: React.FormEvent<HTMLInputElement>) => {
    if(!/^\d+(\.\d)?$/.test(e.currentTarget.value)) {
      e.currentTarget.value = e.currentTarget.value.replace(/[^\d.]/g, '');
    }
  },

  onlyEngAndNumberCanInput: (e: React.FormEvent<HTMLInputElement>) => {
    e.currentTarget.value = e.currentTarget.value.replace(/[^0-9a-zA-Z]/g, '');
  },


  checkNumberEng: (value: string): boolean => {
    return /^[A-Za-z0-9]*$/.test(value);
  },

  numberWithCommas: (value: number) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};
